import { blockCategories } from '../../categories';
import { openMediaPickerModal } from '../../../services/mediaPickerModal';
import { getMediaItemSrc } from '../../bootstrap-components/components/imageCaption/media';

export default (editor, opts = {}) => {
    const domc = editor.DomComponents;
    const bm = editor.BlockManager;
    const pnm = editor.Panels;

    domc.addType('image-box', {
        model: {
            defaults: {
                tagName: 'div',
                draggable: true,
                droppable: true,
                resizable: true,
                attributes: { class: 'image-box-container' },
                style: { width: '100%', height: '500px', 'background-size': 'cover', 'background-repeat': 'no-repeat', 'background-position': '50% 50%' },
                traits: [
                    {
                        type: 'media-library-select',
                        label: false,
                    },
                    {
                        type: 'focal-point',
                        label: false,
                        name: 'focal-point',
                        property: 'background-position',
                    },
                    {
                        type: 'size-with-unit',
                        label: false,
                        name: 'width',
                        property: 'width',
                        displayLabel: 'Breite',
                    },
                    {
                        type: 'size-with-unit',
                        label: false,
                        name: 'height',
                        property: 'height',
                        displayLabel: 'Höhe',
                    },
                    {
                        type: 'checkbox',
                        label: 'Priorität laden',
                        name: 'priorityLoad',
                        changeProp: 1,
                    },
                    {
                        type: 'checkbox',
                        label: 'In hoher Qualität anzeigen ',
                        name: 'highQualityImage',
                        changeProp: 1,
                    },
                    {
                        type: 'responsive-sizes',
                        label: false,
                        name: 'responsiveSizes',
                    },

                ],
            },

            init() {
                this.listenTo(this, 'change:background-image', this.updateBackground);
                this.syncBackgroundImageFromStyle();
            },

            syncBackgroundImageFromStyle() {
                if (this.get('background-image')) {
                    return;
                }

                const bgStyle = this.getStyle()['background-image'];
                if (!bgStyle) {
                    return;
                }

                const match = String(bgStyle).match(/url\(["']?([^"')]+)["']?\)/);
                if (match?.[1]) {
                    this.set('background-image', match[1], { silent: true });
                }
            },

            updateBackground() {
                const img = this.get('background-image');
                this.addStyle({ 'background-image': `url(${img})` });
                this.trigger('change:style');
                this.view.render();
            },
        },

        view: {
            events: {
                dblclick: 'openMediaLibrary',
            },

            openMediaLibrary(e) {
                e?.stopPropagation?.();
                openMediaPickerModal({
                    allowedTypes: ['image'],
                    title: 'Bild auswählen',
                }).then((result) => {
                    if (!result?.url) return;
                    const src =
                        getMediaItemSrc(result) ||
                        result.src ||
                        result.url ||
                        '';
                    this.model.set('background-image', src);
                    this.model.trigger('change:background-image');
                });
            },

            onRender() {
                if (this._autoOpenedMediaPicker) return;

                const bgImage = this.model.get('background-image');
                if (!bgImage) {
                    this._autoOpenedMediaPicker = true;
                    this.openMediaLibrary();
                }
            },
        },
        isComponent(el) {
            if (!el) return;

            const className = el.className && String(el.className);
            const hasClass =
                el?.classList?.contains('image-box-container') ||
                (className &&
                    className.split(/\s+/).includes('image-box-container'));

            if (hasClass) {
                return { type: 'image-box' };
            }
        },
    });

    bm.add('image-box', {
        label: 'Bild-Box',
        category: blockCategories.basic,
        content: { type: 'image-box' },
        media: `<svg viewBox="0 0 24 24">
          <path d="M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M13.96,12.29L11.21,15.83L9.25,13.47L6.5,17H17.5L13.96,12.29Z"></path>
        </svg>`,
    });
};
